<template>
  <div>
    <ScrollView class="DashScrollContainer" :refreshing="refreshing" @onRefresh="onRefresh" :empty="data.length===0">
      <CardNumIndicator  v-for="(item, index) in data" :key="index" :data="item" :estructura="estructura" />
      <template slot="Empty">
          <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import CardNumIndicator from './CardNumIndicator';
export default {
  name: "ComplexIndicatorWrap",
  components: {
    CardNumIndicator,
  },
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    estructura: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
  .DashScrollContainer {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-evenly;
  }
</style>
